module.exports = __webpack_public_path__ + "static/img/y49.119cd8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y49.jpg
// module id = pPLr
// module chunks = 1